import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'ur-loading-spinner',
    standalone: true,
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
    @Input() show = false;
}
